import TextEditor from './TextEditor';

export default {
  ReactComponent: TextEditor,
  bindings: {
    submitLabel: '@',
    placeholder: '@',
    onSubmit: '&',
    onContentChange: '&',
    clearOnSubmit: '=',
    currentUser: '=',
    personas: '=',
    hideSubmit: '=',
    initialValue: '=',
    gifPickerEnabled: '=',
    submitOnEnter: '=',
    onArrowUp: '&?',
    initialAttachments: '=?',
    showErrorToast: '&',
    resizable: '=',
    attachmentsDisabled: '=',
    hasAttachments: '=',
    hiddenToolbarControls: '=',
    quotedMessage: '<',
    removeQuotedMessage: '&',
  },
};
